// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"c2407cb1","182":"55efd402","275":"205c7c92","305":"9d4570e2","520":"f02c4528","724":"8842bc40","893":"a0512be3"}[chunkId] + ".chunk.js";
};